<template>
    <router-view></router-view>
</template>

<script>
    export default {
        middleware: 'auth'
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/step.vue